module.exports = __webpack_public_path__ + "fonts/InterTight-640.142767e.woff2";